@if (generating$ | async; as data) {
	<div class="flex flex-row gap-4 relative">
		@if (data.error) {
			<div class="flex gap-2 items-center">
				<tui-icon
					class="text-red-500"
					size="s"
					icon="@tui.circle-alert"
				/>

				<div class="flex flex-col leading-snug text-left">
					<p>
						{{ 'export.error' | transloco }}
					</p>

					<small class="font-bold">
						{{
							data.startedAt
								| relativeTime
									: {
											showNow: false,
											ago: false,
											exact: true,
									  }
						}}
					</small>
				</div>
			</div>

			<button
				size="s"
				tuiButton
				appearance="secondary"
				(click)="onClear()"
			>
				{{ 'action.clear' | transloco }}
			</button>

			<button size="s" tuiButton (click)="onRetry()">
				{{ 'action.retry' | transloco }}
			</button>
		} @else if (data.endedAt) {
			<div class="flex gap-2 items-center">
				<tui-icon
					class="text-green-500"
					size="s"
					icon="@tui.circle-check"
				/>

				<div class="flex flex-col leading-snug text-left">
					<p>
						{{ 'export.ready' | transloco }}
					</p>
					<small class="font-bold">
						{{
							data.startedAt
								| relativeTime
									: {
											showNow: false,
											ago: false,
											exact: true,
									  }
						}}
					</small>
				</div>
			</div>

			<button
				size="s"
				tuiButton
				appearance="secondary"
				(click)="onClear()"
			>
				{{ 'action.clear' | transloco }}
			</button>

			<button size="s" tuiButton (click)="onDownload()">
				{{ 'action.download' | transloco }}
			</button>
		} @else if (data.startedAt) {
			<div class="flex gap-2 items-center h-8">
				<tui-loader size="s" />

				<div
					class="flex flex-col gap-1 leading-none flex-start w-36 text-left"
				>
					<p>{{ 'export.generating' | transloco }}</p>

					@if (loadingTime$ | async; as time) {
						<small class="font-bold">
							{{ time }}
						</small>
					}
				</div>
			</div>
		}

		@if (!tutorialComplete.valueOf()) {
			<tui-pulse
				[tuiHint]="tutorial"
				[tuiHintManual]="true"
				appearance="accent"
				tuiHintDirection="bottom"
			>
				<ng-template #tutorial>
					<h3 tuiTitle>
						{{ 'export.hint.managing-exports.title' | transloco }}
					</h3>
					<p>
						{{
							'export.hint.managing-exports.description'
								| transloco
						}}
					</p>

					<footer class="flex justify-end w-full">
						<button
							tuiButton
							type="button"
							size="xs"
							(click)="onCompleteTutorial()"
						>
							{{ 'action.got-it' | transloco }}
						</button>
					</footer>
				</ng-template>
			</tui-pulse>
		}
	</div>
}
